// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2412":"a6396f10","9777":"7d0884b0"}[chunkId] + ".chunk.css";
};